import { Search, X } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { useDebouncedSearchParam } from '@/features/discovery/use-debounced-search-param'

export const BrowseSearchBar = () => {
  const [draft, setDraft] = useDebouncedSearchParam('q')

  return (
    <div className="relative w-full">
      <Search
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <Input
        type="search"
        placeholder="Search public projects"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        className="h-11 pl-9 pr-10 text-base"
        aria-label="Search public projects"
      />
      {draft && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Clear search"
          className="absolute right-1 top-1/2 h-9 w-9 -translate-y-1/2"
          onClick={() => setDraft('')}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
